<template>
  <div>
    <h1>404</h1>
    <a href="https://beamy.nz">https://beamy.nz</a>
  </div>
</template>
<style scoped lang="css">
  div {
      margin: auto;
      background-image: url("https://beamy.nz/img/Beamy_helmet.c110cc1c.svg");
      background-repeat: no-repeat;
      background-position: center;
      height: 35rem;
  }
  h1 {
      text-align: center;
      font-size: 10rem;
      color: var(--action-colour);
      padding-top: 10rem;
      animation: blink-effect 1s step-end infinite alternate;
  }

  @keyframes blink-effect {
      /* At 0% (start) and 100% (end), the element is visible */
      0%, 100% {
          opacity: 1;
      }
      /* At 50% (midpoint), the element is transparent */
      50% {
          opacity: 0;
      }
  }
  a {
      text-align: center;
      font-size: 1.5rem;
      color: var(--action-colour);
      width: 100%;
      position: absolute;
      bottom: 1rem;
  }
</style>
